// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#soundTestModalSoundLevelContainer {
  display: flex;
  justify-content: space-between;
}
#soundTestModalSpeakerSoundGainContainer {
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 3vh; */
}
#responseScreen {
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
}

#vocoder-phrase-header {
  z-index: 9999999;
  /* position:"fixed"; */
  margin-top: 20vh;
  margin-left: 10vw;
  font-size: xx-large;
}
#vocoder-phrase-clickable-category {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
  z-index: 9999999;
  /* position: fixed; */
  /* padding-left: 30px; */
  margin-top: 10vh;
  margin-left: 10vw;
}

.vocoder-phrase-category-item {
  display: inline-block;
  padding: 5px;
  border-radius: 7px;
  box-sizing: border-box;
  border: 2px solid rgba(0, 0, 0, 0);
}
.vocoder-phrase-category-item:hover {
  border-color: black;
  cursor: pointer;
}

.vocoder-phrase-category-title {
  /* font-size: 1.5em; */
  font-weight: bold;
  /* color: black; */
}

.vocoder-phrase-item-selected {
  border-color: black;
}

.vocoder-phrase-item-not-selected {
  border-color: rgba(0, 0, 0, 0);
}

#soundParametersFromCalibration {
  line-height: 80%;
}

/* #plotCanvas {
  width: 100%;
  height: 100%; 
} */

/* #soundTestContainer{

} */

#soundTestPlots {
  margin-left: 5%;
  margin-right: 5%;
  /* height: 60vh; */
  /* flex: 1; */
}
`, "",{"version":3,"sources":["webpack://./components/css/vocoderPhrase.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["#soundTestModalSoundLevelContainer {\n  display: flex;\n  justify-content: space-between;\n}\n#soundTestModalSpeakerSoundGainContainer {\n  display: flex;\n  justify-content: space-between;\n  /* margin-bottom: 3vh; */\n}\n#responseScreen {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: flex;\n  flex-direction: column;\n}\n\n#vocoder-phrase-header {\n  z-index: 9999999;\n  /* position:\"fixed\"; */\n  margin-top: 20vh;\n  margin-left: 10vw;\n  font-size: xx-large;\n}\n#vocoder-phrase-clickable-category {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  overflow-x: auto;\n  z-index: 9999999;\n  /* position: fixed; */\n  /* padding-left: 30px; */\n  margin-top: 10vh;\n  margin-left: 10vw;\n}\n\n.vocoder-phrase-category-item {\n  display: inline-block;\n  padding: 5px;\n  border-radius: 7px;\n  box-sizing: border-box;\n  border: 2px solid rgba(0, 0, 0, 0);\n}\n.vocoder-phrase-category-item:hover {\n  border-color: black;\n  cursor: pointer;\n}\n\n.vocoder-phrase-category-title {\n  /* font-size: 1.5em; */\n  font-weight: bold;\n  /* color: black; */\n}\n\n.vocoder-phrase-item-selected {\n  border-color: black;\n}\n\n.vocoder-phrase-item-not-selected {\n  border-color: rgba(0, 0, 0, 0);\n}\n\n#soundParametersFromCalibration {\n  line-height: 80%;\n}\n\n/* #plotCanvas {\n  width: 100%;\n  height: 100%; \n} */\n\n/* #soundTestContainer{\n\n} */\n\n#soundTestPlots {\n  margin-left: 5%;\n  margin-right: 5%;\n  /* height: 60vh; */\n  /* flex: 1; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
